module.exports = __webpack_public_path__ + "static/scale-model-of-manchester-new-hampshire-62a1c4d5b36cc41e858eab07c127cc7e.png";